
import { Helmet } from 'react-helmet';
import FooterSection from '@/components/FooterSection';

const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>Disclaimer - The Liberated Consultant by Rey Marques</title>
        <meta name="description" content="Disclaimer for The Liberated Consultant by Rey Marques." />
      </Helmet>
      
      <div className="min-h-screen bg-book-lightBg">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
            <h1 className="text-3xl md:text-4xl font-bold mb-8 text-book-darkBlue">Disclaimer</h1>
            
            <div className="prose max-w-none">
              <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">Professional Disclaimer</h2>
              <p>The information provided in "The Liberated Consultant" and on this website is for educational purposes only. It is not intended to be a substitute for professional financial, business, or legal advice.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">No Guarantees</h2>
              <p>Results from using our materials are not guaranteed and depend on various factors including but not limited to your background, experience, and work ethic. Past performance is not necessarily indicative of future results.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">Individual Results May Vary</h2>
              <p>The testimonials and examples used on our website and in our book are not intended to represent or guarantee that anyone will achieve the same or similar results.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">Affiliate Disclosure</h2>
              <p>This website may contain affiliate links, which means we may earn a commission if you click through and make a purchase. This does not affect our product recommendations, which are thoroughly researched and genuinely recommended.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">Contact</h2>
              <p>If you have any questions about this disclaimer, please contact us via <a href="https://www.linkedin.com/in/reymarques/" target="_blank" rel="noopener noreferrer" className="text-book-blue hover:text-book-red">LinkedIn</a>.</p>
            </div>
          </div>
        </div>
        <FooterSection />
      </div>
    </>
  );
};

export default Disclaimer;
